var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1894 8.97453C3.59384 7.17706 4.98811 5.76205 6.78866 5.32174C9.24312 4.72153 11.8356 4.72839 14.29 5.3286C16.068 5.76338 17.4807 7.14288 17.9281 8.90646L17.9551 9.01323C18.619 11.6302 18.619 14.3698 17.9551 16.9868L17.9281 17.0935C17.4807 18.8571 16.068 20.2366 14.29 20.6714C11.8356 21.2716 9.24312 21.2785 6.78866 20.6783C4.98811 20.238 3.59384 18.8229 3.1894 17.0255L3.12262 16.7287C2.57013 14.2732 2.57013 11.7268 3.12262 9.27133L3.1894 8.97453Z",
    stroke: "#363853",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0518 16.5841L18.2652 16.6547C18.3207 16.6731 18.3748 16.6953 18.4271 16.7213L20.2513 17.6273C21.6481 18.321 23.2916 17.3121 23.2916 15.7609L23.2916 10.6276C23.2916 8.98873 21.4766 7.98956 20.0774 8.85819L18.4679 9.85733C18.3886 9.90657 18.3152 9.96458 18.249 10.0303L18.1895 10.0894C18.5819 12.2392 18.536 14.448 18.0518 16.5841Z",
    stroke: "#363853",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58325 13H11.2975",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58325 9.75H14.0833",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58325 16.25H9.44039",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.ef50208bdd7fc58f50809bd14e4afd49.svg";
export { ForwardRef as ReactComponent };